export default __webpack_public_path__ + "static/media/icon_page_wrong.59d49355.svg";